import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "@material-ui/lab/Alert";
import Box from "@material-ui/core/Box";
import { RiLockPasswordLine } from "react-icons/ri";
import Typography from "@material-ui/core/Typography";
import { ButtonRow, FormInput, Loader } from "@omnigenbiodata/react";
import MainLayout from "../../../../layout/Main";
import { useAuth } from "@omnigenbiodata/react";

import {
  MESSAGES,
  PASSWORD_REGEX,
} from "../../../../core/constants/forms.constants";

const validationSchema = yup.object().shape({
  firstName: yup.string().required(MESSAGES.firstNameRequired),
  lastName: yup.string().required(MESSAGES.lastNameRequired),
  password: yup
    .string()
    .required(MESSAGES.passwordRequired)
    .matches(PASSWORD_REGEX, MESSAGES.passwordFormat),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], MESSAGES.passwordNoMatch)
    .required(MESSAGES.passwordConfirmRequired),
});

function NewPassword() {
  const { hasError, isBusy, completeNewPassword } = useAuth();

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
    },
    validationSchema,
    onSubmit: (values: any) => {
      completeNewPassword(values);
    },
  });

  return (
    <>
      <MainLayout>
        <form onSubmit={formik.handleSubmit}>
          <Box mb={8}>
            <Typography variant="h4" component="h1" align="center" gutterBottom>
              New Password Required
            </Typography>
            <Typography paragraph variant="body1" align="center">
              Please set up your new details below
            </Typography>
          </Box>
          {hasError && (
            <Box mb={2}>
              <Alert severity="error">
                <Typography variant="body1" paragraph>
                  <strong>Registration Failed</strong>
                </Typography>
                <Typography variant="body1">
                  Your details could not be set. Please try again.
                </Typography>
              </Alert>
            </Box>
          )}
          <Box mb={8}>
            <FormInput
              error={formik.errors.firstName}
              name="firstName"
              label="First Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.firstName}
              value={formik.values.firstName}
            />
            <FormInput
              error={formik.errors.lastName}
              name="lastName"
              label="Last Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.lastName}
              value={formik.values.lastName}
            />
            <FormInput
              error={formik.errors.password}
              name="password"
              label="New Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.password}
              value={formik.values.password}
              type="password"
              startAdornment={<RiLockPasswordLine />}
            />
            <FormInput
              error={formik.errors.confirmPassword}
              name="confirmPassword"
              label="Confirm New Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              touched={formik.touched.confirmPassword}
              value={formik.values.confirmPassword}
              type="password"
              startAdornment={<RiLockPasswordLine />}
            />
          </Box>
          <ButtonRow forwardLabel="Confirm" buttonSize="small" />
        </form>
      </MainLayout>
      <Loader isVisible={isBusy} label="Checking" />
    </>
  );
}

export default NewPassword;
